import { PublicClientApplication, Configuration } from "@azure/msal-browser";
const clientId = process.env.REACT_APP_CLIENT_ID;
const tenantid = process.env.REACT_APP_DIRECTORY_ID;
const redirectUri = process.env.REACT_APP_REDIRECT_URI;

if (!clientId) {
  // Provide more helpful error message
  throw new Error(
    "REACT_APP_CLIENT_ID environment variable is missing. " +
      "In development: check your .env file. " +
      "In production: check Azure Static Web App Configuration settings."
  );
}

console.log(redirectUri)

// const authority = `https://login.microsoftonline.com/${tenantid}`;

const msalConfig: Configuration = {
  auth: {
    clientId: clientId,
    authority: tenantid,
    redirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: true,
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

function logout() {
  msalInstance.logoutRedirect();
}

export { msalInstance, logout };
